import dayjs from 'dayjs'

// 格式化时间
const formateTime = x => {
  if (x) {
    return dayjs(x).format('YYYY-MM-DD HH:mm:ss')
  }
  return '-'
}

// 格式化时间
const formateDate = (x, f = 'YYYY-MM-DD') => {
  if (x) {
    return dayjs(x).format(f)
  }
  return '-'
}

export default {
  formateTime,
  formateDate
}